// ========= API BASE URL ==========
export const API_BASE_URL = process.env.REACT_APP_BASE_URL ?? "";
export const BASE_CRYPTO_SECRET =
  process.env.REACT_APP_BASE_CRYPTO_SECRET ?? "";
export const IMAGE_BASE_URL =
  process.env.REACT_APP_IMAGE_BASE_URL ??
  "https://ren-ath-dev.s3.us-east-2.amazonaws.com/";
const GET_URL =
  process.env.REACT_APP_MODE === "production"
    ? window.location.href
    : "https://internal-pro-shop-store-2.renathlete.net";
// const GET_URL = window.location.href;

export const DIRECT_ACCESS_URL = GET_URL.split("//")[1].split(".")[0];

// =https://ren-ath-dev.s3.us-east-2.amazonaws.com/
// ========= COMMAN API METHODS ==========
export const POST = "POST";
export const GET = "GET";
export const PUT = "PUT";
export const DELETE = "DELETE";
export const BUILD_VERSION = "1.0.4";

export const SizeVerification = [
  // Short codes
  "YS",
  "ys",
  "Ys",
  "yS",
  "YM",
  "ym",
  "Ym",
  "yM",
  "YL",
  "yl",
  "Yl",
  "yL",
  "YSM",
  "ysm",
  "Ysm",
  "ySm",
  "YMD",
  "ymd",
  "Ymd",
  "yMd",
  "YLG",
  "ylg",
  "Ylg",
  "yLg",

  // Abbreviated with space
  "Y S",
  "y s",
  "Y s",
  "y S",
  "Y M",
  "y m",
  "Y m",
  "y M",
  "Y L",
  "y l",
  "Y l",
  "y L",

  // Abbreviated with dash
  "Y-S",
  "y-s",
  "Y-s",
  "y-S",
  "Y-M",
  "y-m",
  "Y-m",
  "y-M",
  "Y-L",
  "y-l",
  "Y-l",
  "y-L",

  // Full words
  "Youth S",
  "youth s",
  "Youth s",
  "youth S",
  "Youth M",
  "youth m",
  "Youth m",
  "youth M",
  "Youth L",
  "youth l",
  "Youth l",
  "youth L",

  // Hyphenated full words
  "Youth-S",
  "youth-s",
  "Youth-s",
  "youth-S",
  "Youth-M",
  "youth-m",
  "Youth-m",
  "youth-M",
  "Youth-L",
  "youth-l",
  "Youth-l",
  "youth-L",

  // Full names
  "YOUTH SMALL",
  "Youth Small",
  "youth small",
  "Youth small",
  "youth Small",
  "YOUTH MEDIUM",
  "Youth Medium",
  "youth medium",
  "Youth medium",
  "youth Medium",
  "YOUTH LARGE",
  "Youth Large",
  "youth large",
  "Youth large",
  "youth Large",

  // Abbreviated full names
  "Y Small",
  "y small",
  "Y small",
  "y Small",
  "Y Medium",
  "y medium",
  "Y medium",
  "y Medium",
  "Y Large",
  "y large",
  "Y large",
  "y Large",

  // Hyphenated full names
  "Y-Small",
  "y-small",
  "Y-small",
  "y-Small",
  "Y-Medium",
  "y-medium",
  "Y-medium",
  "y-Medium",
  "Y-Large",
  "y-large",
  "Y-large",
  "y-Large",
];

export const ORDER_OPTION_UPDATE_TOKEN_SECRET="ItVyCy49mkn27lKnJ/YFfwbmRO+A1+Kixsi2c1VQu8U=";